<template>
  <div class="submit-success-page">
    <div class="success-icon">
      <i class="el-icon-success"></i>
    </div>
    <div class="success-title">考试已提交</div>
    <div class="success-desc">您的考试答卷已成功提交，请等待后续通知。</div>
    
    <div class="actions">
      <el-button type="primary" @click="goHome">返回首页</el-button>
      <el-button @click="goUserCenter">返回用户中心</el-button>
      <el-button @click="goMyExams">返回我的考试</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamSubmitSuccess',
  methods: {
    goHome() {
      this.$router.push('/')
    },
    goUserCenter() {
      this.$router.push('/member-center')
    },
    goMyExams() {
      this.$router.push('/member-center/exams')
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-success-page {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.success-icon {
  font-size: 80px;
  color: #67c23a;
  margin-bottom: 24px;
}

.success-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.success-desc {
  font-size: 14px;
  color: #909399;
  margin-bottom: 32px;
}

.actions {
  display: flex;
  gap: 16px;
  
  .el-button {
    padding: 12px 24px;
  }
}
</style>